import { useI18n } from "@/i18n";
import { PageHero } from "@/pages/PageHero";

const UPDATED = "2026-10-07";

export default function Legal({ k }) {
  const { t, lang } = useI18n();
  const doc = t.legal[k];
  return (
    <div data-testid={`legal-page-${k}`}>
      <PageHero eyebrow="MB300 · by NELVIS FRANCE" title={doc.title} text={`${t.legal.updated}${lang === "fr" ? " : " : ": "}${UPDATED}`} />
      <section className="container-x pb-28">
        <div className="max-w-3xl">
          {doc.sections.map((s, index) => (
            <div key={s.h} className="border-t border-white/12 py-7" data-testid={`legal-${k}-section-${index + 1}`}>
              <h2 className="font-display text-2xl font-bold uppercase" data-testid={`legal-${k}-heading-${index + 1}`}>{s.h}</h2>
              {s.p && <p className="mt-3 leading-relaxed text-[var(--steel)]" data-testid={`legal-${k}-text-${index + 1}`}>{s.p}</p>}
              {s.list && <ul className="mt-3 space-y-2 text-[var(--steel)]">{s.list.map((x, itemIndex) => <li key={x} data-testid={`legal-${k}-item-${index + 1}-${itemIndex + 1}`}>— {x}</li>)}</ul>}
            </div>
          ))}
          {k === "cookiesPolicy" && (
            <button onClick={() => window.dispatchEvent(new Event("mb300:open-cookies"))} data-testid="legal-manage-cookies" className="mt-6 bg-[var(--gold)] px-6 py-3 text-xs font-bold uppercase tracking-[0.16em] text-[var(--night)]">{t.cookies.manage}</button>
          )}
        </div>
      </section>
    </div>
  );
}
